import { RideDelayStatusEnum } from "../../enums";

/** Toolbar counters returned with live-map `rides/search` responses. */
export interface ILiveMapGridToolbarStats {
  countsByDelayStatus: Partial<Record<RideDelayStatusEnum, number>>;
  plannedForNowCount: number;
  newIncidentsTotal: number;
}

export const emptyLiveMapGridToolbarStats = (): ILiveMapGridToolbarStats => {
  const stats: ILiveMapGridToolbarStats = {
    countsByDelayStatus: {},
    plannedForNowCount: 0,
    newIncidentsTotal: 0,
  };
  return stats;
};
